import { signOut, getUserInfo, refreshToken } from "@/services/user";
import JsCookie from "js-cookie";
import { SetStorage, GetStorage } from "@/utils/utils";

let user_info = GetStorage("user_info");
const user = {
  state: {
    userInfo: user_info || null,
    roles: [],
    isGetUserInfo: false,
    isLogin: true,
    operation: {
      job: [],
      candidate: [],
      model: [],
      company: [],
      dashboard: []
    },
    permissionRoutes: []
  },
  mutations: {
    SET_USERINFOSTATUS: (state, payload) => {
      state.isGetUserInfo = payload;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles.map(role => role.role_name);
    },
    SET_TOKEN: (state, payload) => {
      if (payload === "" || payload == undefined) {
        JsCookie.set("token", "");
        JsCookie.set("leapin_refresh_token", "");
        return;
      }
      state.token = payload.token;
      JsCookie.set("token", payload.token);
      JsCookie.set("leapin_refresh_token", payload.refresh);
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
      SetStorage("user_info", userInfo);
    },
    SET_PERMISSION_ROUTES: (state, payload) => {
      state.permissionRoutes = payload;
      let routeList = []
      payload.forEach(item => {
        if (item.code == 1000) { // 候选人首页
          routeList.push({ name: 'My', path: '/CandidateReport' })
        } else if (item.code == 1100) { // 职位
          routeList.push({ name: 'Jobs', path: '/Jobs' })
        } else if (item.code == 1200) { // coach
          routeList.push({ name: 'Coach', path: '/CoachList' })
        } else if (item.code == 3000) { // 技能中心
          routeList.push({ name: 'Skills Lab', path: '/SkillsCentre' })
        } else if (item.code == 2000) { // coach
          routeList.push({ name: 'Home', path: '/CoachShow' })
        } else if (item.code == 2100) { // 预约管理
          routeList.push({ name: 'Engagement', path: '/Engagement' })
        }
      });
      SetStorage("permissionRoutes", JSON.stringify(routeList));
    }
  },

  actions: {
    // 用户名登录
    "user:logIn"({ commit }, payload) {
      return new Promise(resolve => {
        commit("SET_TOKEN", payload);
        let permissionRoutes = [];
        if (payload.user.roles[0].permissions && payload.user.roles[0].permissions.length !== 0) {
          permissionRoutes = payload.user.roles[0].permissions;
          commit("SET_PERMISSION_ROUTES", permissionRoutes);
        }
        resolve();
      });
    },
    // 用户信息获取
    "user:userinfo"({ commit }, payload) {
      return new Promise((resolve) => {
        commit("SET_USERINFOSTATUS", true);
        commit("SET_USERINFO", payload);
        resolve();
      });
    },
    // refreshToken
    "user:refreshToken"({ commit }) {
      return new Promise(resolve => {
        refreshToken({
          refresh_token: JsCookie.get("leapin_refresh_token")
        }).then(res => {
          commit("SET_TOKEN", res);
          window.location.reload();
          resolve();
        });
      });
    },
    // 登出
    "user:logOut"({ commit, state }) {
      return new Promise((resolve, reject) => {
        signOut(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            commit("SET_USERINFO", undefined);
            window.location.reload();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 前端 登出
    "user:fedLogOut"({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_USERINFO", null);
        window.location.reload();
        resolve();
      });
    },
    // 选择页面清理信息
    "user:identity"({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_USERINFO", null);
        resolve();
      });
    }
  }
};

export default user;
